import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import useValidateUser from '../services/useValidateUser';
import Loader from '../components/shared/loader';

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  const { loading, userId, userInfo, refreshSession } = useValidateUser();

  const user = useMemo(() => {
    const userData = {
      id: userId,
      info: userInfo,
      refreshSession,
    };

    // Log the user data to the console when it updates
    console.log('UserContext updated:', userData);

    return userData;
  }, [userId, userInfo, refreshSession]);

  if (loading) {
    return <Loader />; // Render loading at the top-level
  }

  return (
    <UserContext.Provider value={{ user }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
